<template>
  <div class="customerlist">
    <div class="top">
      <div class="querybox">
        <div>
          <p>手机号：</p>
          <el-input
            v-model="queryParams.phone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </div>
        <div>
          <p>邮箱：</p>
          <el-input
            v-model="queryParams.email"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </div>
        <div>
          <p>昵称：</p>
          <el-input
            v-model="queryParams.nickname"
            placeholder="请输入昵称"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>时间筛选：</p>
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        show-overflow-tooltip
      >
        <el-table-column prop="headImage" label="头像">
          <template slot-scope="{ row }">
            <div class="logo">
              <img :src="row.headImg" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="sex" label="性别">
          <template slot-scope="{ row }">
            <span :style="{ color: row.sex === 0 ? '#FF1493' : '#4169E1' }">{{
              row.sex === 0 ? "女" : "男"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="birthday" label="生日">
          <template slot-scope="{ row }">
            {{
              row.birthday ? $moment(row.birthday).format("YYYY-MM-DD") : "未知"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceActiveCode" label="激活码">
          <template slot-scope="{ row }">
            <span
              :style="{ color: row.deviceActiveCode ? '#2E8B57' : '#A52A2A' }"
              >{{
                row.deviceActiveCode ? row.deviceActiveCode : "未激活"
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="lastLogin" label="最近登录时间">
          <template slot-scope="{ row }">
            {{ $moment(row.lastLogin).format("YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="注册时间">
          <template slot-scope="{ row }">
            {{ $moment(row.createdTime).format("YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="{ row }">
            <!-- <span
              :style="{ color: row.status === 0 ? '#5E83F5' : '#EE3A3A' }"
              >{{ row.status === 0 ? "启用" : "禁用" }}</span
            > -->
            <el-button class="green-btn" v-if="row.status === 0"
              >启用</el-button
            >
            <el-button class="red-btn" v-else>禁用</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <div class="handle-box">
              <el-popconfirm
                title="是否启用该用户？"
                popper-class="customerdel-popover"
                @confirm="cancelOrder(scope.row, 0)"
                v-if="Number(scope.row.status) === 1"
              >
                <el-button class="textOrange-btn" slot="reference"
                  >启用</el-button
                >
              </el-popconfirm>
              <el-popconfirm
                title="是否禁用该用户"
                popper-class="customerdel-popover"
                @confirm="cancelOrder(scope.row, 1)"
                v-if="Number(scope.row.status) === 0"
              >
                <el-button class="textOrange-btn" slot="reference"
                  >禁用</el-button
                >
              </el-popconfirm>
              <el-button
                class="textOrange-btn"
                @click="logoutUser(scope.row.id)"
                >注销</el-button
              >
              <el-popconfirm
                title="是否解绑激活码？"
                popper-class="customerdel-popover"
                @confirm="unbindActivationCode(scope.row.id)"
                v-if="scope.row.deviceActiveCode"
              >
                <el-button class="textOrange-btn" slot="reference"
                  >解绑激活码</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 注销弹窗 -->
    <el-dialog
      :visible.sync="logoutVisible"
      width="40%"
      :before-close="logoutClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>注销账户</p>
        <span @click="logoutClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="write-box">
        <div class="tips">
          <i class="el-icon-warning"></i>
          账户注销将永久失效且不可恢复，注销后你账号中的个人资料,课程资料等内容将无法找回,请妥善处理
        </div>
        <div class="reason-box">
          <div
            v-for="(item, index) in reasonList"
            :key="index"
            @click="checkReason(index)"
          >
            <p :class="index === logoutReason ? 'active' : ''"><span></span></p>
            {{ item }}
          </div>
        </div>
        <!-- <div class="write-btn" @click="sumbitWrite">确定注销</div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="logoutClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="sumbitWrite()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, editUserStatus, setLogout } from "@/api/login";
import { setUnbindActivationCode } from "@/api/device";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        phone: "",
        nickname: "",
        startTime: "",
        endTime: "",
        email: "",
      },
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      total: 0, //总数
      userId: null,
      logoutVisible: false,
      reasonList: ["个人信息担忧", "对平台失望", "个人原因", "账户被盗用"],
      logoutReason: 0,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取用户列表
    async init() {
      const res = await getUserList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      console.log(this.queryParams);
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.phone = "";
      this.queryParams.nickname = "";
      this.queryParams.pageNum = 1;
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.email = "";
      this.value = "";
      this.init();
    },
    // 启用禁用
    async cancelOrder(item, status) {
      const params = {
        status,
        id: item.id,
      };
      await editUserStatus(params);
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 注销用户弹窗
    logoutUser(id) {
      this.userId = id;
      this.logoutVisible = true;
    },
    logoutClose() {
      this.logoutVisible = false;
    },
    checkReason(index) {
      this.logoutReason = index;
    },
    async sumbitWrite() {
      const params = {
        id: this.userId,
        logoutReason: this.reasonList[this.logoutReason],
      };
      await setLogout(params);
      this.logoutVisible = false;
      this.$message.success("账户注销成功");
      this.init();
    },
    // 解绑激活码
    async unbindActivationCode(id) {
      await setUnbindActivationCode(id);
      this.$message.success("解绑成功");
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.customerlist {
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        .el-input,
        .el-range-editor {
          width: 200px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox,
    .btnbox {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
  }
  .content {
    .logo {
      display: flex;
      justify-content: center;
      img {
        width: 40px;
        height: 40px;
        border-radius: 100%;
      }
    }
    .textOrange-btn {
      margin: 0 5px;
    }
  }
}

.write-box .tips {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 26px;
  display: flex;
  .el-icon-warning {
    color: #fb9a0e;
    font-size: 21px;
    margin-right: 9px;
    line-height: 26px;
  }
}
.handle-box {
  display: flex;
  justify-content: center;
}
.reason-box {
  background: #f7f7f7;
  border-radius: 4px;
  padding: 11px 24px;
  box-sizing: border-box;
  width: 100%;
  margin: 16px 0;
}

.reason-box > div {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-bottom: 16px;
  cursor: pointer;
  p {
    width: 16px;
    height: 16px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    margin-right: 8px;
  }
  .active {
    border: 1px solid #ff5d2f;
    // padding: 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: block;
      width: 8px;
      height: 8px;
      background: #ff5d2f;
      border-radius: 100%;
    }
  }
}

.write-btn {
  background: #6c24ec;
  border-radius: 12px;
  padding: 20px 0;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  line-height: 1;
  width: 50%;
  margin-top: 32px;
  cursor: pointer;
}
</style>
